<div
  class="flex items-center justify-center gap-6 bg-gray-50 rounded-xl px-6 py-1 h-16 relative"
>
  @if (isRefreshing()) {
    <div class="absolute top-1 right-2 w-2 h-2 bg-brand-primary rounded-full animate-pulse"></div>
  }
  @for (metric of metrics; track $index; let last = $last) {
    <div
      class="flex-1 h-14 px-4 py-1 flex items-center gap-2"
      [class.border-r]="!last"
      [class.border-blue-light]="!last"
    >
      <!-- Icon section (only for first metric - date) -->
      @if (metric.icon) {
        <div class="flex-shrink-0">
          <i [class]="metric.icon + ' text-brand-tertiary text-2xl'"></i>
        </div>
      }

      <!-- Date metric (special case) -->
      @if (metric.isDate) {
        <div
          class="flex justify-center items-center text-text-primary text-base font-normal"
        >
          {{ metric.value }}
        </div>
      }

      <!-- Regular metrics -->
      @if (!metric.isDate) {
        <div class="flex flex-col gap-0.5 w-full">
          <span class="text-text-tertiary text-sm font-normal">{{
            metric.label
          }}</span>
          <span class="text-text-secondary text-2xl font-normal leading-7">{{
            metric.value
          }}</span>
        </div>
      }
    </div>
  }
</div>
